import { ClaimWorkflowStatus } from 'features/claims/types'
import moment from 'moment'
import { getEnumValueFromKey, isEmptyValue } from './misc'

export const numberWithCommas = (value: string): string => {
  const parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const formatDecimals = (value: string | number | boolean): string => {
  // Empty values '' return NaN so is better to catch them here
  if (isNaN(+value) || isEmptyValue(value) || typeof value === 'boolean') return value as string

  const valueAsNumber = parseFloat(value as string)
  return numberWithCommas(valueAsNumber.toFixed(2))
}

export const formatPhoneNumber = (value: string): string => {
  if (value) {
    value = value
      .split(' ')
      .join('')
      .replace(/[+()-]/g, '')
      .slice(-10)
  } else {
    return (value = '')
  }
  const formatedPhone = value.match(/^(\d{3})(\d{3})(\d{4})$/)
  return formatedPhone ? formatedPhone[1] + '-' + formatedPhone[2] + '-' + formatedPhone[3] : value
}

export const phoneNumberAutoFormat = (phoneNumber: string): string => {
  const number = phoneNumber.trim().replace(/[^0-9]/g, '')

  if (number.length < 4) return number
  if (number.length < 7) return number.replace(/(\d{3})(\d{1})/, '$1-$2')
  if (number.length < 10) return number.replace(/(\d{3})(\d{3})(\d{1})/, '$1-$2-$3')
  return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
}

export const formatWorkFlowStatus = (value: string | undefined) => {
  return value ? getEnumValueFromKey(ClaimWorkflowStatus, value) : ClaimWorkflowStatus.unknown
}

export const formatTimeDifference = (start: string, end: string): string => {
  return moment(start).diff(moment(end), 'minutes') + ' mins'
}
